import { useEffect } from 'react';
import { omit } from 'lodash';
import { useStore } from '@tmsw/powerups.store';
import {
  OptionsMenuListItem,
  ListItemPropsOptions,
} from '../../OptionsMenuListItem';
import type { OptionsMenuListItems } from '../../useSettingsConfig';

export type OptionsMenuProps = {
  items: OptionsMenuListItems;
  options: ListItemPropsOptions;
};

function OptionsMenu({ items, options }: OptionsMenuProps) {
  const { __t } = options;

  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const setPageTitle = useStore((state) => state.setPageTitle);
  const pageTitle = __t('pageTitle');
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const inPortrait = useStore((state) => state.inPortrait);

  // TODO: Move this to main component as we should be setting for each panel
  // TODO: Migrate disparate pause conditionals to usePauseConditions
  useEffect(() => {
    setPageTitle(pageTitle);
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
}, [showSettingsPanel, inPortrait, isPauseEnabled]);

  return (
    <section className="SettingsPanel-Container">
      <h1>{__t('optionsMenu')}</h1>
      <ul>
        {items
          .filter(
            (item) =>
              item.name !== 'OptionsMenu' &&
              item.shouldRender({ ...item, options })
          )
          .map((item) => omit(item, 'shouldRender'))
          .map((item) => (
            <OptionsMenuListItem key={item.name} {...item} options={options} />
          ))}
      </ul>
    </section>
  );
}

export default OptionsMenu;

